// A saved specimen, full bleed.
//
// `object-fit: contain` rather than cover, because a saved region carries the
// aspect of the screen it was found on: cropping it to fit a different screen
// would quietly show a different image than the one that was saved. Letterboxing
// against the ink background is the honest option, and in a gallery it reads as
// matting rather than as a mistake.
//
// While the full render runs, the cached thumbnail stands in — blurred and scaled,
// so it reads as an image resolving rather than as a broken one.
// `quiet` suppresses the floating status chip for callers that report progress
// themselves. The shared specimen page does: there, the render finishing IS the
// page's opening moment, so a chip apologising for the wait would undercut it.
const SpecimenImage = ({
            dataUrl,
            placeholder,
            rendering,
            failed,
            alt,
            quiet,
            onTouchStart,
            onTouchEnd
    }) => {

    const shown = dataUrl || placeholder;

    return (
        <div
            className="specimen-stage"
            onTouchStart={onTouchStart}
            onTouchEnd={onTouchEnd}
        >
            {shown &&
                <img
                    src={shown}
                    alt={alt}
                    className={`specimen-image${dataUrl ? '' : ' is-placeholder'}`}
                />
            }

            {rendering && !quiet &&
                <p className="render-note" role="status">
                    {shown ? 'Sharpening' : 'Rendering'}&hellip;
                </p>
            }

            {failed && !quiet &&
                <p className="render-note is-error" role="status">
                    This region couldn&rsquo;t be rendered.
                </p>
            }
        </div>
    );
};

export default SpecimenImage;
